import { render, staticRenderFns } from "./AddNewProject.vue?vue&type=template&id=7aeb4cf4&scoped=true&"
import script from "./AddNewProject.vue?vue&type=script&lang=ts&"
export * from "./AddNewProject.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewProject.vue?vue&type=style&index=0&id=7aeb4cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aeb4cf4",
  null
  
)

component.options.__file = "AddNewProject.vue"
export default component.exports